<script setup lang="ts">
import type { iconName } from "@/Modules/App/Models/Styles/Icons";

import TcIconButton from "@/Components/Extend/TcIconButton.vue";
import TcIcon from "@/Components/Extend/TcIcon.vue";

export interface ItemProps {
  title: string;
  date?: string | Date;
  icon?: iconName;
  isClickable?: boolean;
  isSending?: boolean;
}

const props = defineProps<ItemProps>();

const emit = defineEmits<{
  (e: "select"): void;
  (e: "send"): void;
}>();

const onClick = () => {
  if (props.isClickable) emit("select");
};
</script>

<template>
  <main class="questionnaire" :class="{ 'questionnaire--clickable': isClickable }" @click="onClick">
    <div class="questionnaire__content">
      <div class="questionnaire__content__left">
        <span class="questionnaire__content__left__title">{{ title }}</span>
        <span v-if="date" class="questionnaire__content__date">{{ date }}</span>
      </div>

      <div v-if="props.icon" class="questionnaire__content__right">
        <TcIcon v-if="props.isClickable" :name="props.icon" />
        <TcIconButton v-else :iconName="props.icon" :isLoading="isSending" @click="emit('send')" />
      </div>
    </div>
  </main>
</template>

<style scoped lang="scss">
.questionnaire {
  &__content {
    @include colors.bg(background, base);
    @include sp.padding(false, 3);

    display: flex;
    flex-direction: row;
    align-items: center;

    &__left {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;

      &__title {
        @include text.general(low, l);
        @include colors.color(content, high);
      }

      &__date {
        @include text.general(low, m);
        @include colors.color(content, mid-solid);
      }
    }
  }

  &--clickable {
    cursor: pointer;

    &:hover {
      @include colors.bg(secondary, low-solid);
      @include elevation(s);
    }
  }
}
</style>
